
import React, { useState, useEffect } from 'react';
import AuditList from './AuditList'
import { ExportJsonCsv } from 'react-export-json-csv';
import { Container, Row, Col, Form } from 'react-bootstrap';
import CircularProgress from "@mui/material/CircularProgress";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import LocationNotes from './LocationNotes';

import { apiEndpoint } from '../config/api';
import { apiFetch } from '../services/api';
import { getBuckets } from '../services/seasonSequenceApi';
import { isWorkflowComplete, isBucketAssigned } from '../utils/assignmentStatus';
import { comparisonKey, canonicalizeId, legacyTrim } from '../utils/textCanonicalization';
import { runFullDiagnostic } from '../utils/textCanonicalizationDiagnostic';

export default function SeasonAudit(props) {

    const filename = "Csv-file" + new Date().toISOString().slice(0, 10);
    const headers = [
        { key: 'sKey', name: 'sKey' },
        { key: 'comCode', name: 'comCode' },
        { key: 'comID', name: 'comID' },
        { key: 'facilityName', name: 'facilityName' },
        { key: 'seasonID', name: 'seasonID' },
        { key: 'seasonName', name: 'seasonName' },
        { key: 'seasonDateS', name: 'seasonDateS' },
        { key: 'seasonDateE', name: 'seasonDateE' },
        { key: 'seasonDesc', name: 'seasonDesc' },
        { key: 'priorYearSeasonId', name: 'priorYearSeasonId' },
        { key: 'priorYearSeasonName', name: 'priorYearSeasonName' },
        { key: 'priorSeasonId', name: 'Prior Season ID' },
        { key: 'priorSeasonName', name: 'Prior Season Name' },
        { key: 'ProgramType', name: 'ProgramType' },
        { key: 'TrackingSeason', name: 'TrackingSeason' },
        { key: 'TrackingYear', name: 'TrackingYear' },
        { key: 'emailList', name: 'emailList' },
        { key: 'added', name: 'added' },
        { key: 'accepted', name: 'accepted' }
    ]

    const comcodes = props.comcodes;
    const handleUpdateLocationDimFacility = props.handleUpdateLocationDimFacility;
    const seasonDataForQueries = props.seasonDataForQueries;

    const [mergedData, setMergedData] = useState([]);
    const [baseData, setBaseData] = useState([]);
    const [newData, setNewData] = useState([]);
    const [error, setError] = useState("");
    const [isInAsynch, setisInAsynch] = useState(false);

    // Franchise Calendar bucket cache, keyed by `${com_code}|${trackingYear}`.
    // Populated lazily for the distinct (com_code, trackingYear) pairs visible in the
    // grid, so the Franchise Bucket dropdown in each AuditRow has its options without a
    // per-row fetch. Value: { loaded, buckets:[...] }.
    const [bucketsByKey, setBucketsByKey] = useState({});

    useEffect(() => {
        const keysNeeded = new Set();
        for (const r of mergedData) {
            const ty = r.TrackingYear ?? r.trackingYear;
            // `com_code ?? comCode` is NOT defensive padding: the two row shapes really do
            // differ. The saved-row transform sets both spellings; the warehouse/new-row
            // transform sets ONLY `comCode`. Reading `r.com_code` alone therefore skips
            // every brand-new row -- invisibly, wherever a franchise-year happened to also
            // contain a saved row to supply the key, and visibly ("…") where it did not.
            const cc = r.com_code ?? r.comCode;
            // EVERY row with a franchise-year needs its bucket options, saved or not.
            // A brand-new season is bucketed in the SAME Add/Update click that creates it,
            // so gating this fetch on an existing identity (as it once did) left the
            // dropdown with no options to render.
            if (cc && ty) {
                keysNeeded.add(`${cc}|${ty}`);
            }
        }
        const toFetch = [...keysNeeded].filter((k) => !(k in bucketsByKey));
        if (toFetch.length === 0) return;

        let cancelled = false;
        (async () => {
            const updates = {};
            for (const key of toFetch) {
                const [com_code, trackingYear] = key.split('|');
                try {
                    const res = await getBuckets(com_code, trackingYear);
                    updates[key] = { loaded: true, buckets: res.buckets || [] };
                } catch (e) {
                    updates[key] = { loaded: true, buckets: [], error: true };
                }
            }
            if (!cancelled) setBucketsByKey((prev) => ({ ...prev, ...updates }));
        })();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mergedData]);

    const [dateStartSearchStartOfRange, setDateStartSearchStartOfRange] = useState(new dayjs().subtract(15, 'day'));
    const [dateStartSearchEndOfRange, setDateStartSearchEndOfRange] = useState(new dayjs().add(6, 'month'));

    // const seasonDataForQueries = mergedData;

    const updateDateSearchLKSITableStartDate = (date) => {
        changeSearchLKSITableStartDate(date);
    }


    const updateDateSearchSearchEndOfRange = (date) => {
        changeStartSearchEndOfRange(date);
    }

    const changeSearchLKSITableStartDate = (date) => {
        setDateStartSearchStartOfRange(date)

    }

    const changeStartSearchEndOfRange = (date) => {
        setDateStartSearchEndOfRange(date)
    }


    // let mergedDataCopy = mergedData;

    let mergedDataCopy = mergedData.map((mergedObj) => {

        const transformed = {
            ...mergedObj
        }

        return transformed;

    })

    const setBaseDBData = (dbData) => {
        setBaseData(dbData);
    }

    useEffect(() => {

        const tempfunction = async () => {

            const responseFromUpdateDatabase = await updateSeasonsFromDatabase();
            const responseFromUpdateDataFromWarehouse = await updateDataFromWarehouseQuery();
            const responseFromMergeLists = await mergeLists();
        }
        tempfunction();

        // updateInAsyncronousManner();

    }, []);

    // run this when the 'baseData' state variable has changed. Note that this is how we
    // are handling the asyncronous aspect of setting state.
    useEffect(() => {
        const tempfunction = async () => {
            // const responseFromUpdateDatabase = await updateSeasonsFromDatabase();
            // console.log("responseFromUpdateDatabase result: ", responseFromUpdateDatabase)

            const responseFromMergeLists = await mergeLists();
        }
        tempfunction();

    }, [newData, baseData]); //array is list of variables that will cause this to rerun if changed
    // only rerendering on newData because baseData is always also called and it's done first
    //with a wait

    // READ-ONLY text-canonicalization diagnostic (Phase 1). OFF by default; opt in with
    //   localStorage.setItem('canonDiag','1')  then reload.
    // It NEVER touches the merge, display, or any stored value -- it only measures whether adopting the
    // comparison key would preserve every accepted row and how much false-positive drift it would
    // resolve, and logs the report to the console. Does nothing unless enabled.
    useEffect(() => {
        const enabled = typeof window !== 'undefined' && window.localStorage
            && window.localStorage.getItem('canonDiag') === '1';
        if (!enabled) return;
        if (baseData.length === 0 || newData.length === 0) {
            console.log('[canonDiag] waiting for BOTH baseData and newData to finish loading...');
            return;
        }
        try {
            const report = runFullDiagnostic(baseData, newData);
            const a = report.acceptance;
            console.log('[canonDiag] ===================== Phase-1 diagnostic (read-only) =====================');
            console.log('[canonDiag] accepted rows:', a.acceptedRowCount,
                        '| comparable:', a.comparableAcceptedRowCount,
                        '| preserved:', a.acceptedRowsPreserved);
            console.log('[canonDiag] compatibility violations (EXPECT 0):', a.compatibilityViolations.length,
                        a.compatibilityViolations);
            console.log('[canonDiag] false-positive drift resolved | accepted:', a.falsePositiveDriftResolvedAccepted.length,
                        '| all rows:', a.falsePositiveDriftResolvedAllRows);
            console.log('[canonDiag] resolved detail (accepted):', a.falsePositiveDriftResolvedAccepted);
            console.table(report.collisions.map((s) => ({ stage: s.stage, introduced: s.introduced, expected: s.expected, review: s.review })));
            report.collisions.filter((s) => s.review > 0).forEach((s) =>
                console.log(`[canonDiag] REVIEW collisions @ "${s.stage}":`, s.reviewExamples));
            console.log('[canonDiag] ==========================================================================');
        } catch (e) {
            console.error('[canonDiag] diagnostic threw:', e);
        }
    }, [baseData, newData]);



    const updateInAsyncronousManner = async () => {

        try {
            setisInAsynch(true);

            // // const foo = await updateSeasonsFromDatabase();
            // updateSeasonsFromDatabase();
            const responseFromUpdateDatabase = await updateSeasonsFromDatabase();

            const responseFromWarehouseQuery = await updateDataFromWarehouseQuery();
            // updateDataFromWarehouseQuery();
            const responseFromMergedList = await mergeListsDontSetState();
        }
        catch (e) {
            console.log("updateInAsynchronousManner just threw. Here's the error e: ", e)
        }
        finally {
            setisInAsynch(false)
        }
    }


    const updateSeasonsFromDatabase = async () => {

        return new Promise(async function (resolve, reject) {

            const localDate = dayjs.utc(dateStartSearchStartOfRange);
            const nextStepLocalDate = localDate.tz("America/Los_Angeles");
            const localDateString = nextStepLocalDate.toISOString().split('T');
            const justTheLocaldate = localDateString[0];

            const dateString = dateStartSearchStartOfRange.toISOString().split('T');
            const justTheDate = dateString[0];

            const endDateString = dateStartSearchEndOfRange.toISOString().split('T');
            const justTheEndDate = endDateString[0];

            let removeSpecialCharsSeasonName = "";
            let removeSpecialCharsFacilityName = "";

            apiFetch(`${apiEndpoint}/savedseasons-daterange/${justTheDate}/${justTheEndDate}`)
                .then((response) => response.json())

                .then((actualData) => {
                    // throw new Error("Thrown from the fetch()");

                    const transformedData = (actualData.data || []).map((seasonObj) => {
                    const dateSeasonStartStringS = seasonObj.seasondates;
                    const dateS = new Date(dateSeasonStartStringS);
                    const justTheDateS = isNaN(dateS.getTime())
                        ? ""
                        : dateS.toISOString().split('T')[0];

                    const dateSeasonStartStringE = seasonObj.seasondatee;
                    const dateE = new Date(dateSeasonStartStringE);
                    const justTheDateE = isNaN(dateE.getTime())
                        ? ""
                        : dateE.toISOString().split('T')[0];

                    const seasonTrack = seasonObj.trackingseason;
                    const yearTrack = seasonObj.trackingyear;
                    const comID = seasonObj.comid;

                    removeSpecialCharsSeasonName = (seasonObj.seasonname || "").replace(/[^a-zA-Z0-9 ]/g, '');
                    removeSpecialCharsFacilityName = (seasonObj.facilityname || "").replace(/[^a-zA-Z0-9 ]/g, '');

                    const transformed = {
                        ...seasonObj,
                        sKey: seasonObj.skey,
                        comCode: seasonObj.com_code,
                        com_code: seasonObj.com_code,
                        seasonID: seasonObj.seasonid,
                        seasonName: removeSpecialCharsSeasonName,
                        facilityName: removeSpecialCharsFacilityName,
                        // Canonical facility identity (NOT cleaned) -- the saved app row column is
                        // snake_case facility_id; normalize null -> "" so it compares cleanly.
                        facilityId: seasonObj.facility_id ?? "",
                        seasonDateS: justTheDateS,
                        seasonDateE: justTheDateE,
                        seasonDesc: seasonObj.seasondesc,
                        priorYearSeasonId: seasonObj.prioryearseasonid,
                        priorYearSeasonName: seasonObj.prioryearseasonname,
                        priorSeasonId: seasonObj.priorseasonid,
                        priorSeasonName: seasonObj.priorseasonname,
                        ProgramType: seasonObj.programtype,
                        programType: seasonObj.programtype,
                        trackingSeason: seasonTrack?.toString?.() ?? "",
                        trackingYear: yearTrack?.toString?.() ?? "",
                        TrackingSeason: seasonTrack?.toString?.() ?? "",
                        TrackingYear: yearTrack?.toString?.() ?? "",
                        emailList: seasonObj.emaillist,
                        added: seasonObj.added,
                        accepted: seasonObj.accepted,
                        comID: comID?.toString?.() ?? ""
                    };
                    return transformed;
                });
                    setBaseDBData(transformedData);
                    resolve('success')
                })
                .catch(function (e) {
                    console.log("updateSeasonsFromDatabase call failed with the following error e:  ", e);
                    reject('failure')
                })
        })
    }

    const updateDataFromWarehouseQuery = async () => {
    return new Promise(async function (resolve, reject) {
        setisInAsynch(true);

        const dateString = dateStartSearchStartOfRange.toISOString().split('T');
        const justTheDate = dateString[0];

        const endDateString = dateStartSearchEndOfRange.toISOString().split('T');
        const justTheEndDate = endDateString[0];

        // Helper: convert warehouse IDs like season_dsr_sam_arenasports_4798 -> 4798
        const getShortId = (value) => {
            if (value === null || value === undefined) return "";
            const stringValue = String(value);

            if (stringValue.includes("_")) {
                return stringValue.split("_").pop();
            }

            return stringValue;
        };

        apiFetch(`${apiEndpoint}/new-season-pull/${justTheDate}/${justTheEndDate}`)
            .then((response) => response.json())
            .then((actualData) => {
                const newDataWithAddedFields = (actualData.data || []).map((seasonObj) => {
                    const dateSeasonStartStringS = seasonObj.seasonDateS;
                    const dateS = new Date(dateSeasonStartStringS);
                    const justTheDateS = isNaN(dateS.getTime())
                        ? ""
                        : dateS.toISOString().split('T')[0];

                    const dateSeasonStartStringE = seasonObj.seasonDateE;
                    const dateE = new Date(dateSeasonStartStringE);
                    const justTheDateE = isNaN(dateE.getTime())
                        ? ""
                        : dateE.toISOString().split('T')[0];

                    let seasonGuess = "no guess";
                    let trackingYearGuess = "2022";
                    let removeSpecialCharsSeasonName = "";
                    let removeSpecialCharsSeasonDesc = "";
                    let removeSpecialCharsPriorYearSeasonName = "";
                    let removeSpecialCharsPriorSeasonName = "";
                    let removeSpecialCharsFacilityName = "";

                    if (justTheDateS) {
                        switch (justTheDateS.split('-')[1]) {
                            case '12':
                            case '01':
                            case '02':
                                seasonGuess = "4";
                                break;
                            case '03':
                            case '04':
                            case '05':
                                seasonGuess = "1";
                                break;
                            case '06':
                            case '07':
                            case '08':
                                seasonGuess = "2";
                                break;
                            case '09':
                            case '10':
                            case '11':
                                seasonGuess = "3";
                                break;
                            default:
                                seasonGuess = "0";
                                break;
                        }

                        trackingYearGuess = justTheDateS.split('-')[0];
                    }

                    if (seasonObj.seasonName) {
                        removeSpecialCharsSeasonName = seasonObj.seasonName.replace(/[^a-zA-Z0-9 ]/g, '');
                    }

                    if (seasonObj.seasonDesc) {
                        removeSpecialCharsSeasonDesc = seasonObj.seasonDesc.replace(/[^a-zA-Z0-9 ]/g, '');
                    }

                    if (seasonObj.priorYearSeasonName) {
                        removeSpecialCharsPriorYearSeasonName = seasonObj.priorYearSeasonName.replace(/[^a-zA-Z0-9 ]/g, '');
                    }

                    if (seasonObj.priorSeasonName) {
                        removeSpecialCharsPriorSeasonName = seasonObj.priorSeasonName.replace(/[^a-zA-Z0-9 ]/g, '');
                    }

                    if (seasonObj.facilityName) {
                        removeSpecialCharsFacilityName = seasonObj.facilityName.replace(/[^a-zA-Z0-9 ]/g, '');
                    }

                    // Full warehouse IDs from the proc
                    const warehouseSeasonID = seasonObj.seasonID ? String(seasonObj.seasonID) : "";
                    const warehousePriorYearSeasonId = seasonObj.priorYearSeasonId
                        ? String(seasonObj.priorYearSeasonId)
                        : "";
                    const warehousePriorSeasonId = seasonObj.priorSeasonId
                        ? String(seasonObj.priorSeasonId)
                        : "";

                    // Legacy / display-friendly IDs
                    const shortSeasonID = getShortId(warehouseSeasonID);
                    const shortPriorYearSeasonId = getShortId(warehousePriorYearSeasonId);
                    const shortPriorSeasonId = getShortId(warehousePriorSeasonId);

                    const normalizedComID = seasonObj.comID !== null && seasonObj.comID !== undefined
                        ? String(seasonObj.comID)
                        : "";

                    const newTransformed = {
                        ...seasonObj,

                        // Keep legacy names/shape for UI + older logic
                        comCode: seasonObj.comCode,
                        comID: normalizedComID,
                        facilityName: removeSpecialCharsFacilityName,
                        // Canonical facility identity from the proc (NOT cleaned); normalize null -> "".
                        facilityId: seasonObj.facilityId ?? "",
                        seasonID: shortSeasonID,
                        seasonName: removeSpecialCharsSeasonName,
                        seasonDateS: justTheDateS,
                        seasonDateE: justTheDateE,
                        seasonDesc: removeSpecialCharsSeasonDesc,
                        priorYearSeasonId: shortPriorYearSeasonId,
                        priorYearSeasonName: removeSpecialCharsPriorYearSeasonName,
                        priorSeasonId: shortPriorSeasonId,
                        priorSeasonName: removeSpecialCharsPriorSeasonName,

                        // Preserve full warehouse IDs for matching / future use
                        warehouseSeasonID: warehouseSeasonID,
                        warehousePriorYearSeasonId: warehousePriorYearSeasonId,
                        warehousePriorSeasonId: warehousePriorSeasonId,

                        // Keep old app behavior
                        sKey: "0-" + normalizedComID + "-" + shortSeasonID,
                        emailList: seasonObj.emailList ? seasonObj.emailList.replace(/,/g, ';') : "",
                        ProgramType: "0",
                        TrackingSeason: seasonGuess,
                        TrackingYear: trackingYearGuess,
                        added: seasonObj.added === "FALSE" ? false : !!seasonObj.added,
                        accepted: seasonObj.accepted === "FALSE" ? false : !!seasonObj.accepted,

                        // Also keep camelCase variants used elsewhere
                        programType: "0",
                        trackingSeason: seasonGuess,
                        trackingYear: trackingYearGuess
                    };

                    return newTransformed;
                });

                setNewData(newDataWithAddedFields);
                setisInAsynch(false);
                resolve('success');
            })
            .catch((e) => {
                console.log("updateDataFromWarehouseQuery call failed with the following error e:  ", e);
                setisInAsynch(false);
                reject('failure');
            });
    });
};

    // Drift comparators now come from the shared canonicalization library (Phase 2). Comparison-only:
    // these decide drift; they never change a displayed, persisted, or API-payload value.
    //   * NAME / description fields use `comparisonKey` -- case/whitespace/Unicode-tolerant, and
    //     PROVABLY a refinement of the old normalization, so no currently-accepted row can be
    //     un-accepted by the change (see docs/projects/shared-text-normalization-plan.md).
    //   * legacy IDs use `canonicalizeId` -- trim + "0" -> "" sentinel; behavior UNCHANGED from the
    //     former normalizeLegacyId (a saved 0 vs a warehouse null/empty is still "no drift").
    //   * facilityId and the date fields keep TRIM ONLY (`legacyTrim`): a real facility move or date
    //     change must still drift, so they are deliberately NOT routed through the name key.
    const normalizeText = legacyTrim; // facilityId + dates only; names moved to comparisonKey

const mergeLists = async () => {
    return new Promise(async function (resolve, reject) {
        setisInAsynch(true);

        try {
            const mergedList = baseData.map((seasonObj) => {
                const transformed = {
                    ...seasonObj
                };

                return transformed;
            });

            newData.forEach((seasonObj) => {
                const index = baseData.findIndex((element) => {
                    if (element.sKey === seasonObj.sKey) {
                        return true;
                    }
                    return false;
                });

                if (index === -1) {
                    mergedList.push(seasonObj);
                } else {
                    if (comparisonKey(seasonObj.facilityName) !== comparisonKey(mergedList[index].facilityName)) {
                        const tempFacility = mergedList[index].facilityName;
                        mergedList[index].facilityName = seasonObj.facilityName;
                        mergedList[index].OrigFacilityName = tempFacility;
                        // Facility RENAME: keep OrigFacilityName as visible context, but do NOT
                        // reset accepted -- owners rename facilities often; the season still belongs
                        // to the same facility, so a name change alone must not force reacceptance.
                    }

                    if (normalizeText(seasonObj.facilityId) !== normalizeText(mergedList[index].facilityId)) {
                        // Facility MOVE: the canonical facility_id changed (not just the display
                        // name), so the season is at a DIFFERENT facility -> drift. Record the saved
                        // id as OrigFacilityId (highlight + Needs Work) and reset acceptance.
                        const tempFacilityId = mergedList[index].facilityId;
                        mergedList[index].facilityId = seasonObj.facilityId;
                        mergedList[index].OrigFacilityId = tempFacilityId;
                        mergedList[index].accepted = false;
                    }

                    if (comparisonKey(seasonObj.seasonName) !== comparisonKey(mergedList[index].seasonName)) {
                        const tempSeasonName = mergedList[index].seasonName;
                        mergedList[index].seasonName = seasonObj.seasonName;
                        mergedList[index].OrigSeasonName = tempSeasonName;
                        mergedList[index].accepted = false;
                    }

                    if (normalizeText(seasonObj.seasonDateS) !== normalizeText(mergedList[index].seasonDateS)) {
                        const tempDate = mergedList[index].seasonDateS;
                        mergedList[index].seasonDateS = seasonObj.seasonDateS;
                        mergedList[index].OrigSeasonDateS = tempDate;
                        mergedList[index].accepted = false;
                    }

                    if (normalizeText(seasonObj.seasonDateE) !== normalizeText(mergedList[index].seasonDateE)) {
                        const tempDate = mergedList[index].seasonDateE;
                        mergedList[index].seasonDateE = seasonObj.seasonDateE;
                        mergedList[index].OrigSeasonDateE = tempDate;
                        mergedList[index].accepted = false;
                    }

                    if (comparisonKey(seasonObj.seasonDesc) !== comparisonKey(mergedList[index].seasonDesc)) {
                        const tempSeasonDesc = mergedList[index].seasonDesc;
                        mergedList[index].seasonDesc = seasonObj.seasonDesc;
                        mergedList[index].OrigSeasonDesc = tempSeasonDesc;
                        mergedList[index].accepted = false;
                    }

                    if (
                        canonicalizeId(seasonObj.seasonID) !==
                        canonicalizeId(mergedList[index].seasonID)
                    ) {
                        const tempSeasonId = mergedList[index].seasonID;
                        mergedList[index].seasonID = seasonObj.seasonID;
                        mergedList[index].OrigSeasonID = tempSeasonId;
                        mergedList[index].accepted = false;
                    }

                    if (
                        canonicalizeId(seasonObj.priorYearSeasonId) !==
                        canonicalizeId(mergedList[index].priorYearSeasonId)
                    ) {
                        const tempPriorYearSeasonId = mergedList[index].priorYearSeasonId;
                        mergedList[index].priorYearSeasonId = seasonObj.priorYearSeasonId;
                        mergedList[index].OrigPriorYearSeasonId = tempPriorYearSeasonId;
                        mergedList[index].accepted = false;
                    }

                    if (comparisonKey(seasonObj.priorYearSeasonName) !== comparisonKey(mergedList[index].priorYearSeasonName)) {
                        const tempPriorYearSeasonName = mergedList[index].priorYearSeasonName;
                        mergedList[index].priorYearSeasonName = seasonObj.priorYearSeasonName;
                        mergedList[index].OrigPriorYearSeasonName = tempPriorYearSeasonName;
                        mergedList[index].accepted = false;
                    }

                    // Prior Season baseline established by the one-time backfill
                    // (migration 2026-07-15_prior_season_backfill@v2-corrected), so normal
                    // drift comparison applies -- identical treatment to Prior Year Season.
                    if (
                        canonicalizeId(seasonObj.priorSeasonId) !==
                        canonicalizeId(mergedList[index].priorSeasonId)
                    ) {
                        const tempPriorSeasonId = mergedList[index].priorSeasonId;
                        mergedList[index].priorSeasonId = seasonObj.priorSeasonId;
                        mergedList[index].OrigPriorSeasonId = tempPriorSeasonId;
                        mergedList[index].accepted = false;
                    }

                    if (comparisonKey(seasonObj.priorSeasonName) !== comparisonKey(mergedList[index].priorSeasonName)) {
                        const tempPriorSeasonName = mergedList[index].priorSeasonName;
                        mergedList[index].priorSeasonName = seasonObj.priorSeasonName;
                        mergedList[index].OrigPriorSeasonName = tempPriorSeasonName;
                        mergedList[index].accepted = false;
                    }

                    mergedList[index].added = mergedList[index].added ? mergedList[index].added : false;
                    mergedList[index].accepted = mergedList[index].accepted ? mergedList[index].accepted : false;
                }
            });

            const tempMergedList = mergedList.map((mergedObj) => {
                const transformed = {
                    ...mergedObj
                };

                return transformed;
            });

            setMergedData(tempMergedList);
            setisInAsynch(false);
            resolve('success');
        } catch (error) {
            console.log("\n\n", error);
            setisInAsynch(false);
            reject('failure');
        } finally {
            setisInAsynch(false);
        }
    });
};

    const mergeListsDontSetState = async () => {
        return new Promise(async function (resolve, reject) {
            setisInAsynch(true);
            try {
                const mergedList = baseData.map((seasonObj) => {
                    const transformed = {
                        ...seasonObj
                    };

                    return transformed;
                });

                newData.forEach((seasonObj) => {
                    const index = baseData.findIndex((element) => {
                        if (element.sKey === seasonObj.sKey) {
                            return true;
                        }
                        return false;
                    });

                    if (index === -1) {
                        mergedList.push(seasonObj);
                    } else {
                        if (comparisonKey(seasonObj.facilityName) !== comparisonKey(mergedList[index].facilityName)) {
                            const tempFacility = mergedList[index].facilityName;
                            mergedList[index].facilityName = seasonObj.facilityName;
                            mergedList[index].OrigFacilityName = tempFacility;
                            // Facility RENAME: keep OrigFacilityName as visible context, but do NOT
                            // reset accepted -- a name change alone must not force reacceptance.
                        }

                        if (normalizeText(seasonObj.facilityId) !== normalizeText(mergedList[index].facilityId)) {
                            // Facility MOVE (see mergeLists): canonical facility_id change -> drift,
                            // OrigFacilityId marker + reset acceptance.
                            const tempFacilityId = mergedList[index].facilityId;
                            mergedList[index].facilityId = seasonObj.facilityId;
                            mergedList[index].OrigFacilityId = tempFacilityId;
                            mergedList[index].accepted = false;
                        }

                        if (comparisonKey(seasonObj.seasonName) !== comparisonKey(mergedList[index].seasonName)) {
                            const tempSeasonName = mergedList[index].seasonName;
                            mergedList[index].seasonName = seasonObj.seasonName;
                            mergedList[index].OrigSeasonName = tempSeasonName;
                            mergedList[index].accepted = false;
                        }

                        if (normalizeText(seasonObj.seasonDateS) !== normalizeText(mergedList[index].seasonDateS)) {
                            const tempDate = mergedList[index].seasonDateS;
                            mergedList[index].seasonDateS = seasonObj.seasonDateS;
                            mergedList[index].OrigSeasonDateS = tempDate;
                            mergedList[index].accepted = false;
                        }

                        if (normalizeText(seasonObj.seasonDateE) !== normalizeText(mergedList[index].seasonDateE)) {
                            const tempDate = mergedList[index].seasonDateE;
                            mergedList[index].seasonDateE = seasonObj.seasonDateE;
                            mergedList[index].OrigSeasonDateE = tempDate;
                            mergedList[index].accepted = false;
                        }

                        if (comparisonKey(seasonObj.seasonDesc) !== comparisonKey(mergedList[index].seasonDesc)) {
                            const tempSeasonDesc = mergedList[index].seasonDesc;
                            mergedList[index].seasonDesc = seasonObj.seasonDesc;
                            mergedList[index].OrigSeasonDesc = tempSeasonDesc;
                            mergedList[index].accepted = false;
                        }

                        if (
                            canonicalizeId(seasonObj.seasonID) !==
                            canonicalizeId(mergedList[index].seasonID)
                        ) {
                            const tempSeasonId = mergedList[index].seasonID;
                            mergedList[index].seasonID = seasonObj.seasonID;
                            mergedList[index].OrigSeasonID = tempSeasonId;
                            mergedList[index].accepted = false;
                        }

                        if (
                            canonicalizeId(seasonObj.priorYearSeasonId) !==
                            canonicalizeId(mergedList[index].priorYearSeasonId)
                        ) {
                            const tempPriorYearSeasonId = mergedList[index].priorYearSeasonId;
                            mergedList[index].priorYearSeasonId = seasonObj.priorYearSeasonId;
                            mergedList[index].OrigPriorYearSeasonId = tempPriorYearSeasonId;
                            mergedList[index].accepted = false;
                        }

                        if (comparisonKey(seasonObj.priorYearSeasonName) !== comparisonKey(mergedList[index].priorYearSeasonName)) {
                            const tempPriorYearSeasonName = mergedList[index].priorYearSeasonName;
                            mergedList[index].priorYearSeasonName = seasonObj.priorYearSeasonName;
                            mergedList[index].OrigPriorYearSeasonName = tempPriorYearSeasonName;
                            mergedList[index].accepted = false;
                        }

                        // Prior Season baseline established by the one-time backfill
                        // (migration 2026-07-15_prior_season_backfill@v2-corrected), so normal
                        // drift comparison applies -- identical treatment to Prior Year Season.
                        if (
                            canonicalizeId(seasonObj.priorSeasonId) !==
                            canonicalizeId(mergedList[index].priorSeasonId)
                        ) {
                            const tempPriorSeasonId = mergedList[index].priorSeasonId;
                            mergedList[index].priorSeasonId = seasonObj.priorSeasonId;
                            mergedList[index].OrigPriorSeasonId = tempPriorSeasonId;
                            mergedList[index].accepted = false;
                        }

                        if (comparisonKey(seasonObj.priorSeasonName) !== comparisonKey(mergedList[index].priorSeasonName)) {
                            const tempPriorSeasonName = mergedList[index].priorSeasonName;
                            mergedList[index].priorSeasonName = seasonObj.priorSeasonName;
                            mergedList[index].OrigPriorSeasonName = tempPriorSeasonName;
                            mergedList[index].accepted = false;
                        }

                        mergedList[index].added = mergedList[index].added ? mergedList[index].added : false;
                        mergedList[index].accepted = mergedList[index].accepted ? mergedList[index].accepted : false;
                    }
                });

            const tempMergedList = mergedList.map((mergedObj) => {
                const transformed = {
                    ...mergedObj
                };

                return transformed;
            });

            mergedDataCopy = tempMergedList;

            setisInAsynch(false);
            resolve('success');
        } catch (error) {
            console.log("\n\n", error);
            setisInAsynch(false);
            reject('failure');
        } finally {
            setisInAsynch(false);
        }
    });
};

    const handleDeleteFromRESTApi = async (sKey) => {

        return new Promise(async function (resolve, reject) {

            setisInAsynch(true);
            const requestOptions = {
                method: 'DELETE'
            };

            try {
                // const response = await apiFetch(`${apiEndpoint}/remove/${sKey}`, requestOptions);
                const response = await apiFetch(`${apiEndpoint}/savedseasons-remove/${sKey}`, requestOptions);
                const json = await response.json();
                // Immediately reconcile the parent row so the Status chip/filter and header
                // counts reflect the delete without waiting for the async re-fetch.
                setMergedData((prev) => prev.map((row) =>
                    row.sKey === sKey ? { ...row, accepted: false, season_sequence: null } : row
                ));
                const responseFromUpdateDatabase = await updateSeasonsFromDatabase();
                // updateSeasonsFromDatabase();
                setisInAsynch(false);
                resolve('success')


            }
            catch (e) {
                console.log("Throw in handleDeleteFromRESTAPI e: ", e);
                reject('failure')
            }
            finally {
                setisInAsynch(false);
            }

        })
    }

    // THE single persistence operation for an Operational Season row: metadata AND the
    // Franchise Calendar bucket, in one call, committed by one backend transaction.
    // There is no second assign request and no ordering for this function to manage --
    // whether the row exists, whether it has an identity yet, and whether Tracking Season
    // was just edited are all backend concerns now.
    const handleAddOrUpdateFromRestApi = async (seasonRowData) => {
        setisInAsynch(true);

        const body = {
            sKey: seasonRowData.sKey,
            com_code: seasonRowData.com_code,
            comID: seasonRowData.comID,
            facilityName: seasonRowData.facilityName,
            facilityId: seasonRowData.facilityId,
            seasonID: seasonRowData.seasonID,
            seasonName: seasonRowData.seasonName,
            seasonDateS: seasonRowData.seasonDateS,
            seasonDateE: seasonRowData.seasonDateE,
            seasonDesc: seasonRowData.seasonDesc,
            priorYearSeasonId: seasonRowData.priorYearSeasonId,
            priorYearSeasonName: seasonRowData.priorYearSeasonName,
            priorSeasonId: seasonRowData.priorSeasonId,
            priorSeasonName: seasonRowData.priorSeasonName,
            programType: seasonRowData.programType,
            emailList: seasonRowData.emailList,
            trackingYear: seasonRowData.trackingYear,
            trackingSeason: seasonRowData.trackingSeason,
            added: seasonRowData.added,
            accepted: true,
        };

        // PROPERTY PRESENCE, matching the backend contract: send season_sequence only
        // when a bucket is actually selected. Omitting the key means "no bucket work --
        // leave any stored assignment alone". Sending null would be rejected (400):
        // clearing an assignment is not a supported operation, so a null could only ever
        // be a mistake, and the backend surfaces it rather than guessing.
        if (isBucketAssigned(seasonRowData.season_sequence)) {
            body.season_sequence = Number(seasonRowData.season_sequence);
        }

        try {
            const response = await apiFetch(`${apiEndpoint}/savedseasons-add-update`, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: { 'Content-type': 'application/json; charset=UTF-8' },
            });
            const json = await response.json().catch(() => ({}));

            // apiFetch is a thin fetch wrapper: it resolves for 4xx/5xx too. Without this
            // check a rejected save (e.g. an invalid bucket -> 404, whole request rolled
            // back) would be reported as success and the grid would refresh away the
            // user's unsaved edits. Mirrors parseResponse() in services/seasonSequenceApi.js.
            if (!response.ok) {
                throw new Error(json.message || `Save failed with status ${response.status}`);
            }

            // Merge the AUTHORITATIVE stored state the backend just re-read inside its
            // transaction. Not the submitted values: on a DERIVE the Tracking Season/Year
            // come from the bucket, and on a MISMATCH the Tracking Season is deliberately
            // preserved while season_sequence moves. Echoing what we sent would misreport
            // both. This also gives a brand-new row its identity immediately.
            setMergedData((prev) => prev.map((row) =>
                row.sKey === seasonRowData.sKey
                    ? {
                        ...row,
                        lksi_rev_and_rollseasonsid: json.lksi_rev_and_rollseasonsid ?? row.lksi_rev_and_rollseasonsid,
                        accepted: json.accepted ?? true,
                        season_sequence: json.season_sequence ?? null,
                        ...(json.trackingseason != null
                            ? { trackingSeason: String(json.trackingseason), TrackingSeason: String(json.trackingseason) }
                            : {}),
                        ...(json.trackingyear != null
                            ? { trackingYear: String(json.trackingyear), TrackingYear: String(json.trackingyear) }
                            : {}),
                        // The save re-synced this row to the current warehouse values, so the
                        // drift markers no longer apply. Cleared here so the Status chip and
                        // header counts settle immediately; the re-fetch below recomputes
                        // drift from scratch anyway.
                        OrigFacilityName: undefined, OrigFacilityId: undefined, OrigSeasonName: undefined,
                        OrigSeasonDateS: undefined, OrigSeasonDateE: undefined,
                        OrigSeasonDesc: undefined, OrigSeasonID: undefined,
                        OrigPriorYearSeasonId: undefined, OrigPriorYearSeasonName: undefined,
                        OrigPriorSeasonId: undefined, OrigPriorSeasonName: undefined,
                      }
                    : row
            ));
            await updateSeasonsFromDatabase();
            return json;
        }
        catch (e) {
            console.log("Throw in handleAddOrUpdateFromRestApi e: ", e)
            // Rethrow so the row can surface the reason and KEEP the user's edits. The
            // backend request was atomic: on failure nothing was written, so there is
            // nothing to reconcile and the local form is still valid unsaved intent.
            throw e;
        }
        finally {
            setisInAsynch(false);
        }
    }


    const handleUpdateDates = () => {

        updateInAsyncronousManner();

    }


    const totalRows = mergedDataCopy.length;
    // Status work queue summary: the same isWorkflowComplete predicate as the
    // Status column filter, so the header and the column can never disagree.
    // "Needs Work" is the single primary number; the Row Saved / Bucket Status
    // columns explain *why* a given row still needs work, so the summary doesn't
    // duplicate any one reason.
    const completeRows = mergedDataCopy.filter(r => isWorkflowComplete(r.accepted, r.season_sequence)).length;
    const needsWorkRows = totalRows - completeRows;

    return (

        <Container fluid>

            {/* ── Page description ── */}
            <Box sx={{ mt: 2, mb: 1 }}>
                <Typography variant="body2" color="text.secondary">
                    Review and reconcile warehouse seasons against saved records. Use the date range to filter by season start date, then refresh to reload.
                </Typography>
            </Box>

            {/* ── Controls toolbar ── */}
            <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>

            <Grid container alignItems="center" justify="center" >

                <Grid item md={6}>
                    <p></p>
                    <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Season Start Date - Start of Range"
                                value={dateStartSearchStartOfRange}
                                onChange={(date) => updateDateSearchLKSITableStartDate(date)}
                            />
                            <DatePicker
                                label="Season Start Date - End of Range"
                                value={dateStartSearchEndOfRange}
                                onChange={(date) => updateDateSearchSearchEndOfRange(date)}
                            />
                        </LocalizationProvider>
                    </>
                    <Button variant="contained" color="primary" onClick={e => handleUpdateDates(e)}>
                        Refresh Dates
                    </Button>
                </Grid>
                <Grid item md={4}>
                    <p></p>
                    {isInAsynch ? <CircularProgress /> : <></>}
                </Grid>
                <Grid item>
                    <p></p>
                    <ExportJsonCsv className='btn btn-primary' headers={headers} items={mergedData} fileTitle={filename}>DownLoad CSV</ExportJsonCsv>
                </Grid>

            </Grid>
            </Paper>

            {/* ── Summary row ── */}
            <Box sx={{ display: 'flex', gap: 3, mb: 1, px: 0.5 }}>
                <Typography variant="body2"><strong>Total:</strong> {totalRows}</Typography>
                <Typography variant="body2" color={needsWorkRows > 0 ? 'warning.main' : 'text.secondary'}>
                    <strong>Needs Work:</strong> {needsWorkRows}
                </Typography>
                <Typography variant="body2" color="success.main"><strong>Complete:</strong> {completeRows}</Typography>
                <Typography variant="body2" sx={{ ml: 'auto' }} color="text.secondary">
                    {dateStartSearchStartOfRange.format('MMM D, YYYY')} – {dateStartSearchEndOfRange.format('MMM D, YYYY')}
                </Typography>
            </Box>

            <hr></hr>
            <Grid>
                <Grid >

                    <AuditList seasonsArray={mergedDataCopy} comcodes={comcodes} seasonDataForQueries={seasonDataForQueries}
                        handleUpdateLocationDimFacility={handleUpdateLocationDimFacility}
                        deleteSqlRow={handleDeleteFromRESTApi} addOrUpdateSQLRow={handleAddOrUpdateFromRestApi}
                        updateInAsyncronousManner={updateInAsyncronousManner} bucketsByKey={bucketsByKey} />

                </Grid>

            </Grid>

        </Container>

    );

}